export class ImageFile{
    name:string;
    file: File;
    imageUrl: any;
    fileSizeError: any;
    errorUpload: any;
}


// WEBPACK FOOTER //
// ./src/app/shared/_data-model/image-file.ts